import React from "react";
import AuthInterceptor from "../../interceptors/authInterceptor.jsx";
import Layout from "../../components/layout/UserLayout.jsx";

function Principal(props) {
  return (
    <Layout>
      <AuthInterceptor>
        <div className="mx-20 bg-green-500 text-3xl text-white">Principal</div>;
      </AuthInterceptor>
    </Layout>
  );
}

export default Principal;
